export default "__VITE_ASSET__BBfQwX0J__"